export default __webpack_public_path__ + "static/media/ShareBtn.8e32d50a.svg";